<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#ffffff"
  type="ball-scale-multiple"
  [fullScreen]="true"
>
  <div style="">
    <!-- <img src="assets/ePIN/epin_blue_fav.svg" alt="EPINLABS Logo" style="width: 80px; z-index: 2; position: relative;" /> -->
    <p style="font-size: 20px; color: white;;">Loading...</p>
  </div>
</ngx-spinner>

